/**
 * 
 */
export const config = {
        mastercraft: {
            parts_services: [{
                Title: 'Parts & Services',
                Description: '',
                GoToURL: '',
                GoToLinkTarget: "_blank",
                GoToText: '',
                VideoURL: '',
                ImageURL: '/img/brand/MasterCraft/banners/new-used-boats-banner.jpg',
                MobileImageURL: '/img/brand/MasterCraft/banners/new-used-boats-banner.jpg',
                ImageAltText: 'parts and services'
            }, ],
            contact_us: [{
                Title: 'Contact Us',
                Description: '',
                GoToURL: '',
                GoToLinkTarget: "_blank",
                GoToText: '',
                VideoURL: '',
                ImageURL: '/img/brand/MasterCraft/banners/contact-us-banner.jpg',
                MobileImageURL: '/img/brand/MasterCraft/banners/contact-us-banner.jpg',
                ImageAltText: 'contact us'
            }],
            trade_in: [{
                Title: 'Trade-In',
                Description: '',
                GoToURL: '',
                GoToLinkTarget: "_blank",
                GoToText: '',
                VideoURL: '',
                ImageURL: '/img/brand/MasterCraft/banners/trade-in-banner.jpg',
                MobileImageURL: '/img/brand/MasterCraft/banners/trade-in-banner.jpg',
                ImageAltText: 'Trade-In'
            }],
            about_us: [{
                Title: 'About Us',
                Description: '',
                GoToURL: '',
                GoToLinkTarget: "_blank",
                GoToText: '',
                VideoURL: '',
                ImageURL: '/img/brand/MasterCraft/banners/about-us-banner.jpg',
                MobileImageURL: '/img/brand/MasterCraft/banners/about-us-banner.jpg',
                ImageAltText: 'about us'
            }],
            profile: [{
                Title: 'Meet Our Team',
                Description: '',
                GoToURL: '',
                GoToLinkTarget: "_blank",
                GoToText: '',
                VideoURL: '',
                ImageURL: '/img/brand/MasterCraft/banners/news-banner.jpg',
                MobileImageURL: '/img/brand/MasterCraft/banners/news-banner.jpg',
                ImageAltText: 'profile'
            }],
            request_brochure: [{
                Title: 'Request Brochure',
                Description: '',
                GoToURL: '',
                GoToLinkTarget: "_blank",
                GoToText: '',
                VideoURL: '',
                ImageURL: '/img/brand/MasterCraft/banners/request-brochure-banner.jpg',
                MobileImageURL: '/img/brand/MasterCraft/banners/request-brochure-banner.jpg',
                ImageAltText: 'request brochure'
            }],
            data: [{
                    Title: window.DEALER_LOCATION?.name,
                    Description: '',
                    GoToURL: '/Contact/ContactUs',
                    GoToLinkTarget: '',
                    GoToText: 'Contact Us',
                    VideoURL: '',
                    ImageURL: '/img/brand/MasterCraft/banners/home/mc-microsites-banner-2022.jpg',
                    MobileImageURL: '/img/brand/MasterCraft/banners/home/mc-microsites-banner-2022.jpg',
                    ImageAltText: ''
                }
            ]
        },
        aviara: {
            parts_services: [{
                Title: 'Parts & Services',
                Description: '',
                GoToURL: '',
                GoToLinkTarget: "_blank",
                GoToText: '',
                VideoURL: '',
                ImageURL: '/img/brand/Aviara/banners/banner.jpg',
                MobileImageURL: '/img/brand/Aviara/banners/banner.jpg',
                ImageAltText: 'parts & services'
            }, ],
            contact_us: [{
                Title: 'Contact us',
                Description: '',
                GoToURL: '',
                GoToLinkTarget: "_blank",
                GoToText: '',
                VideoURL: '',
                ImageURL: '/img/brand/Aviara/banners/banner.jpg',
                MobileImageURL: '/img/brand/Aviara/banners/banner.jpg',
                ImageAltText: 'contact us'
            }],
            trade_in: [{
                Title: 'Trade-In',
                Description: '',
                GoToURL: '',
                GoToLinkTarget: "_blank",
                GoToText: '',
                VideoURL: '',
                ImageURL: '/img/brand/Aviara/banners/banner.jpg',
                MobileImageURL: '/img/brand/Aviara/banners/banner.jpg',
                ImageAltText: 'Trade-In'
            }],
            about_us: [{
                Title: 'About Us',
                Description: '',
                GoToURL: '',
                GoToLinkTarget: "_blank",
                GoToText: '',
                VideoURL: '',
                ImageURL: '/img/brand/Aviara/banners/banner.jpg',
                MobileImageURL: '/img/brand/Aviara/banners/banner.jpg',
                ImageAltText: 'about us'
            }],
            profile: [{
                Title: 'Meet Our Team',
                Description: '',
                GoToURL: '',
                GoToLinkTarget: "_blank",
                GoToText: '',
                VideoURL: '',
                ImageURL: '/img/brand/Aviara/banners/banner.jpg',
                MobileImageURL: '/img/brand/Aviara/banners/banner.jpg',
                ImageAltText: 'profile'
            }],
            request_brochure: [{
                Title: 'Request Brochure',
                Description: '',
                GoToURL: '',
                GoToLinkTarget: "_blank",
                GoToText: '',
                VideoURL: '',
                ImageURL: '/img/brand/Aviara/banners/banner.jpg',
                MobileImageURL: '/img/brand/Aviara/banners/banner.jpg',
                ImageAltText: 'request brochure'
            }],
            data: [{
                Title: 'SURF SUPREMACY',
                Description: 'Meet the XStar S',
                GoToURL: 'https://www.mastercraft.com/boats/xstar-s/',
                GoToLinkTarget: "_blank",
                GoToText: 'Learn more',
                VideoURL: 'https://www.aviaraboats.com/media/cms/video/AVIARA_-_0752_2019_MainPageAV32_AV36_Tout_v2.mp4',
                ImageURL: '',
                MobileImageURL: '',
                ImageAltText: ''
            }]
        },
        crest: {
            parts_services: [{
                Title: 'Parts & Services',
                Description: '',
                GoToURL: '',
                GoToLinkTarget: "_blank",
                GoToText: '',
                VideoURL: '',
                ImageURL: '/img/brand/Crest/banners/new-used-boats-banner.jpg',
                MobileImageURL: '/img/brand/Crest/banners/new-used-boats-banner.jpg',
                ImageAltText: 'parts & services'
            }, ],
            contact_us: [{
                Title: 'Contact Us',
                Description: '',
                GoToURL: '',
                GoToLinkTarget: "_blank",
                GoToText: '',
                VideoURL: '',
                ImageURL: '/img/brand/Crest/banners/contact-us-banner.jpg',
                MobileImageURL: '/img/brand/Crest/banners/contact-us-banner.jpg',
                ImageAltText: 'contact us'
            }],
            trade_in: [{
                Title: 'Trade-In',
                Description: '',
                GoToURL: '',
                GoToLinkTarget: "_blank",
                GoToText: '',
                VideoURL: '',
                ImageURL: '/img/brand/Crest/banners/trade-in-banner.jpg',
                MobileImageURL: '/img/brand/Crest/banners/new-used-boats-banner.jpg',
                ImageAltText: 'Trade-In'
            }],
            about_us: [{
                Title: 'About Us',
                Description: '',
                GoToURL: '',
                GoToLinkTarget: "_blank",
                GoToText: '',
                VideoURL: '',
                ImageURL: '/img/brand/Crest/banners/about-us-banner.jpg',
                MobileImageURL: '/img/brand/Crest/banners/about-us-banner.jpg',
                ImageAltText: 'about us'
            }],
            profile: [{
                Title: 'Meet Our Team',
                Description: '',
                GoToURL: '',
                GoToLinkTarget: "_blank",
                GoToText: '',
                VideoURL: '',
                ImageURL: '/img/brand/Crest/banners/news-banner.jpg',
                MobileImageURL: '/img/brand/Crest/banners/news-banner.jpg',
                ImageAltText: 'profile'
            }],
            request_brochure: [{
                Title: 'Request Brochure',
                Description: '',
                GoToURL: '',
                GoToLinkTarget: "_blank",
                GoToText: '',
                VideoURL: '',
                ImageURL: '/img/brand/Crest/banners/request-brochure-banner.jpg',
                MobileImageURL: '/img/brand/Crest/banners/new-used-boats-banner.jpg',
                ImageAltText: 'request brochure'
            }],
            data: [{
                    Title: 'Crest\'s Signature Series',
                    Description: '',
                    GoToURL: 'https://crestpontoonboats.com/models/caribbean-platinum',
                    GoToLinkTarget: "_blank",
                    GoToText: 'Meet the Caribbean Platinum',
                    VideoURL: '',
                    ImageURL: '/img/brand/Crest/banners/Crest-micro-header-Caribbean-Platinum.jpg',
                    MobileImageURL: '/img/brand/Crest/banners/Crest-micro-header-Caribbean-Platinum.jpg',
                    ImageAltText: ''
                },
                {
                    Title: 'For the Days that Matter Most',
                    Description: '',
                    GoToURL: 'https://crestpontoonboats.com/models/caribbean-rs',
                    GoToLinkTarget: "_blank",
                    GoToText: 'Meet the Caribbean RS',
                    VideoURL: '',
                    ImageURL: '/img/brand/Crest/banners/Crest-micro-header-Caribbean-RS.jpg',
                    MobileImageURL: '/img/brand/Crest/banners/Crest-micro-header-Caribbean-RS.jpg',
                    ImageAltText: ''
                },
                {
                    Title: 'For the Days that Matter Most',
                    Description: '',
                    GoToURL: 'https://crestpontoonboats.com/models/classic-lx',
                    GoToLinkTarget: "_blank",
                    GoToText: 'Meet the Classic Fish',
                    VideoURL: '',
                    ImageURL: '/img/brand/Crest/banners/Crest-micro-header-Classic-Fish.jpg',
                    MobileImageURL: '/img/brand/Crest/banners/Crest-micro-header-Classic-Fish.jpg',
                    ImageAltText: ''
                },
                {
                    Title: 'Crest\'s Signature Series',
                    Description: 'Meet the Classic LX',
                    GoToURL: 'https://crestpontoonboats.com/models/classic-lx',
                    GoToLinkTarget: "_blank",
                    GoToText: 'Learn more',
                    VideoURL: '',
                    ImageURL: '/img/brand/Crest/banners/Crest-micro-header-Classic-LX.jpg',
                    MobileImageURL: '/img/brand/Crest/banners/Crest-micro-header-Classic-LX.jpg',
                    ImageAltText: ''
                },
                {
                    Title: 'Ultimate Luxury Pontoons',
                    Description: '',
                    GoToURL: 'https://crestpontoonboats.com/models/continental-nx',
                    GoToLinkTarget: "_blank",
                    GoToText: 'Meet the Continental NX',
                    VideoURL: '',
                    ImageURL: '/img/brand/Crest/banners/Crest-micro-header-Continental-NX.jpg',
                    MobileImageURL: '/img/brand/Crest/banners/Crest-micro-header-Continental-NX.jpg',
                    ImageAltText: ''
                },
                {
                    Title: 'Ultimate Luxury Pontoons',
                    Description: '',
                    GoToURL: 'https://crestpontoonboats.com/models/luxury',
                    GoToLinkTarget: "_blank",
                    GoToText: 'Meet the Luxury Line',
                    VideoURL: '',
                    ImageURL: '/img/brand/Crest/banners/ultimate-luxury-pontoons.jpg',
                    MobileImageURL: '/img/brand/Crest/banners/ultimate-luxury-pontoons.jpg',
                    ImageAltText: ''
                }
            ]
        },
        nauticstar: {
            parts_services: [{
                Title: 'Parts & Services',
                Description: '',
                GoToURL: '',
                GoToLinkTarget: "_blank",
                GoToText: '',
                VideoURL: '',
                ImageURL: '/img/brand/NauticStar/banners/banner.jpg',
                MobileImageURL: '/img/brand/NauticStar/banners/banner.jpg',
                ImageAltText: 'parts and services'
            }, ],
            contact_us: [{
                Title: 'Contact Us',
                Description: '',
                GoToURL: '',
                GoToLinkTarget: "_blank",
                GoToText: '',
                VideoURL: '',
                ImageURL: '/img/brand/NauticStar/banners/banner.jpg',
                MobileImageURL: '/img/brand/NauticStar/banners/banner.jpg',
                ImageAltText: 'contact us'
            }],
            trade_in: [{
                Title: 'Trade-In',
                Description: '',
                GoToURL: '',
                GoToLinkTarget: "_blank",
                GoToText: '',
                VideoURL: '',
                ImageURL: '/img/brand/NauticStar/banners/banner.jpg',
                MobileImageURL: '/img/brand/NauticStar/banners/banner.jpg',
                ImageAltText: 'Trade-In'
            }],
            about_us: [{
                Title: 'About Us',
                Description: '',
                GoToURL: '',
                GoToLinkTarget: "_blank",
                GoToText: '',
                VideoURL: '',
                ImageURL: '/img/brand/NauticStar/banners/banner.jpg',
                MobileImageURL: '/img/brand/NauticStar/banners/banner.jpg',
                ImageAltText: 'about us'
            }],
            profile: [{
                Title: 'Meet Our Team',
                Description: '',
                GoToURL: '',
                GoToLinkTarget: "_blank",
                GoToText: '',
                VideoURL: '',
                ImageURL: '/img/brand/NauticStar/banners/banner.jpg',
                MobileImageURL: '/img/brand/NauticStar/banners/banner.jpg',
                ImageAltText: 'profile'
            }],
            request_brochure: [{
                Title: 'Request Brochure',
                Description: '',
                GoToURL: '',
                GoToLinkTarget: "_blank",
                GoToText: '',
                VideoURL: '',
                ImageURL: '/img/brand/NauticStar/banners/banner.jpg',
                MobileImageURL: '/img/brand/NauticStar/banners/banner.jpg',
                ImageAltText: 'request brochure'
            }],
            data: [{
                    Title: 'Charting the Course',
                    Description: 'LEARNING ON A LEGACY',
                    GoToURL: 'https://nauticstarboats.com/flibs-2021/',
                    GoToLinkTarget: "_blank",
                    GoToText: 'Learn more',
                    VideoURL: '',
                    ImageURL: 'https://nauticstarboats.com/content/uploads/2021/10/2021FLIBS_NauticStar_Header.jpg',
                    MobileImageURL: 'https://nauticstarboats.com/content/uploads/2021/10/2021FLIBS_NauticStar_Header.jpg',
                    ImageAltText: ''
                },
                {
                    Title: 'NauticStar News',
                    Description: 'Product and Lifestyle Information',
                    GoToURL: 'https://nauticstarboats.com/news/',
                    GoToLinkTarget: "_blank",
                    GoToText: 'Explore innovations',
                    VideoURL: '',
                    ImageURL: 'https://nauticstarboats.com/content/uploads/2021/10/all-new-2022-24-legacy.jpg',
                    MobileImageURL: 'https://nauticstarboats.com/content/uploads/2021/10/all-new-2022-24-legacy.jpg',
                    ImageAltText: ''
                },
                {
                    Title: 'Charting The Course',
                    Description: 'Email Newsletter from NauticStar',
                    GoToURL: 'https://nauticstarboats.com/offshore-series/24-xs/',
                    GoToLinkTarget: "_blank",
                    GoToText: 'Exlore surfstar',
                    VideoURL: '',
                    ImageURL: 'https://nauticstarboats.com/content/uploads/2021/09/NSB-008-BlogHeader-V1.jpg',
                    MobileImageURL: 'https://nauticstarboats.com/content/uploads/2021/09/NSB-008-BlogHeader-V1.jpg',
                    ImageAltText: ''
                },
                {
                    Title: 'VISIT US OCTOBER 27-31, 2021',
                    Description: 'RESERVE YOUR FLIBS GIFT',
                    GoToURL: 'https://nauticstarboats.com/flibs-2021/',
                    GoToLinkTarget: "_blank",
                    GoToText: 'Learn more',
                    VideoURL: '',
                    ImageURL: 'https://nauticstarboats.com/content/uploads/2021/10/BANNER-HOME.jpg',
                    MobileImageURL: 'https://nauticstarboats.com/content/uploads/2021/10/BANNER-HOME.jpg',
                    ImageAltText: ''
                }
            ]
        }
    }
    /**
     * 
     * @param {*} brand 
     * @param {*} key 
     * @returns 
     */
const getBannerData = (brand, key) => config[brand][key]
    /**
     * 
     */
export default getBannerData;